import {DATE_API} from '../../common/constants';
import dayjs from 'dayjs';

export function formatDateForURL(date) {
    return dayjs(date).format(DATE_API);
}
